export default __webpack_public_path__ + "static/media/slider.c1f87ac2.jpg";